export default __webpack_public_path__ + "static/media/avatar11.77ac7713.png";